import { useMemo } from "react"
import { useSelector } from "react-redux"
const useFlattenModules = () => {
  const { modules, loading, hasFetched } = useSelector((state) => ({
    modules: state.Sidebar.modules,
    loading: state.Sidebar.loading,
    hasFetched: state.Sidebar.hasFetched,
  }))
  const subModules = useMemo(() => {
    if (!hasFetched) return undefined
    const subs = modules.flatMap((module) => module?.sub_modules)
    return subs?.length ? subs : []
  }, [modules, hasFetched])
  return {
    subModules,
    loading,
    hasFetched,
  }
}
export default useFlattenModules
